import { Component, OnInit, ViewChild } from '@angular/core';
import { CalculatorJsFormService } from './shared/calculatorjs.form.service';
import { ToastrService } from 'ngx-toastr';
import {
  BaseControl,
  DynamicFormComponent
} from '@app/shared';

@Component({
  selector: 'iw-calculatorjs',
  templateUrl: './calculatorjs.component.html',
  styleUrls: ['./calculatorjs.component.scss'],
  providers: [CalculatorJsFormService]
})
export class CalculatorjsComponent implements OnInit {

  // Controles del formulario
  controls: BaseControl<any>[] = [];
  // Referencia al formulario dinámico de crear y editar tareas
  @ViewChild('form') form: DynamicFormComponent;

  constructor(
    private toastr: ToastrService,
    private cjfs: CalculatorJsFormService
  ) { }

  ngOnInit() {
    this.controls = this.cjfs.getFields();
  }

  /**
   * Calcular la operacion ingresada
   *
   * @param {*} data
   * @memberof CalculatorjsComponent
   */
  calculate(data: any) {
    try {
      // Llamada a la libreria para ejecutar los calculos de las operaciones
      const calc = require('calculatorjs');
      if (data.txtOperactionCalculator) {
        const result = calc(data.txtOperactionCalculator);
        this.form.updateFormControl('txtResult', result);
      }
    } catch (error) {
      this.toastr.error('Error gramatical');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/examples/calculatorjs/calculatorjs.component.ts